<template>
  <div :class="['app', this.name]">
    <AppHeader />
    <router-view></router-view>
  </div>
</template>

<script>
import AppHeader from '../components/Header'

export default {
  name: 'full',
  components: {
    AppHeader
  },
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched
    }
  }
}
</script>



// WEBPACK FOOTER //
// Full.vue?15405cb7